import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';

const VideoCard = ({ video }) => {
  const { videoId, title, published, thumbnail, link } = video;

  return (
    <motion.a 
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="video-card group relative block bg-dark-700/40 rounded-xl overflow-hidden border border-white/5 hover:border-cyan-500/30 transition-all duration-500"
      whileHover={{ y: -8 }}
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden bg-dark-800">
        <img 
          src={thumbnail} 
          alt={title} 
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100"
        />
        
        {/* Subtle Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-60" />
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-lg font-bold text-white mb-3 line-clamp-2 leading-snug group-hover:text-cyan-200 transition-colors">
          {title}
        </h3>
        
        <p className="text-xs text-gray-500 font-mono tracking-wider uppercase">
          {published ? format(new Date(published), 'MMM dd, yyyy') : 'Recent'}
        </p>
      </div>

      {/* Soft Glow Border Effect */}
      <div className="absolute inset-0 rounded-xl border border-cyan-500/0 group-hover:border-cyan-500/20 pointer-events-none transition-all duration-500" />
      <div className="absolute inset-0 bg-cyan-400/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
    </motion.a>
  );
};

export default VideoCard;